import { useMemo } from "react";
import DatePicker, { DateObject } from "react-multi-date-picker";
import { InputGroup, Label } from "reactstrap";
import CalendarTrigger from "../CalendarTrigger";

type Props = {
  darkMode?: boolean;
  dateRange: (DateObject | null)[];
  handleDateRange: (value: any) => void; // react-multi-date-picker passes DateObject[] for range
  handleClearDateRange: () => void;
  SELECT_DATES: string;
};

export default function RangePickerIconTrigger({
  darkMode = false,
  dateRange,
  handleDateRange,
  handleClearDateRange,
  SELECT_DATES,
}: Props) {
  const hasRange = !!dateRange?.[0] && !!dateRange?.[1];

  const rangeLabel = useMemo(() => {
    if (!hasRange) return "Select date range";
    const [start, end] = dateRange as [DateObject, DateObject];
    return `${start.format("YYYY/MM/DD")} — ${end.format("YYYY/MM/DD")}`;
  }, [dateRange, hasRange]);

  return (
    <InputGroup className="flatpicker-calender">
      <Label className="f-16">{SELECT_DATES}</Label>

      <DatePicker
        value={dateRange}
        onChange={handleDateRange}
        range
        rangeHover
        format="YYYY/MM/DD"
        editable={false}
        calendarPosition="bottom-left"
        portal
        render={(value, openCalendar) => (
          <CalendarTrigger
            darkMode={darkMode}
            rangeLabel={rangeLabel}
            hasRange={hasRange}
            onOpen={openCalendar}
            onClear={handleClearDateRange}
          />
        )}
      />
    </InputGroup>
  );
}
